import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uploadfile_photo" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Добавьте фото эскизного проекта")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"-6px"} }, "Пример изображения"),
  /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/mo/sketchmini.png" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_FileUpload, {
        document: _ctx.document,
        file_upload_name: 'sketchmini_file',
        upload_text: 'Добавьте фото в поле ниже. Соотношение сторон 3Шx2В. Пример: 3480px x 2320px'
      }, null, 8, ["document", "upload_text"])
    ]),
    _hoisted_4
  ]))
}